import { Box, Text } from '@factorialco/deprecated-design-system'
import type { GetTimeSettingsCustomTimeRangeCategoriesQuery } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

type TimeSettingsCustomTimeRangeCategory =
  GetTimeSettingsCustomTimeRangeCategoriesQuery['timeSettings']['customTimeRangeCategoriesConnection']['nodes'][number]

interface Props {
  category: TimeSettingsCustomTimeRangeCategory
}

const ArchivedItem = ({ category }: Props) => {
  const { name, timeType } = category

  const timeTypeTextConfig: Record<string, string | null> = {
    regular: i18n.t('work_time_categories.time_type.regular'),
    overtime: i18n.t('work_time_categories.time_type.overtime'),
    any_time: null,
  }

  const timeTypeCopy = timeTypeTextConfig[timeType]

  return (
    <Box
      flexDirection="row"
      gap="s16"
      alignItems="flexStart"
      justifyContent="spaceBetween"
      width="full"
      component="li"
    >
      <Box>
        <Text size="300" color="grey800" weight="medium" ellipsis>
          {name}
        </Text>
      </Box>
      <Box justifyContent="flexEnd">
        {timeTypeCopy && (
          <Text size="300" color="grey800" weight="medium">
            {timeTypeCopy}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default observer(ArchivedItem)
